module.exports = __webpack_public_path__ + "img/icons8-no-entry.748ec1fb.svg";